import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexSwitch',
  setup(__props) {

const customSwitch = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/customSwitch.vue"))
const iconsSwitch = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/iconsSwitch.vue"))
const uncheckedSwitch = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/uncheckedSwitch.vue"))
const bordersIcons = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/bordersIcons.vue"))
const disabledOutline = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/disabledOutline.vue"))
const variationSwitches = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/variationSwitches.vue"))
const switchSizing = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/switchSizing.vue"))
const switchIcons = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/switchIcons.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Form Widgets",
      title: "Switch"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(customSwitch)),
        _createVNode(_unref(iconsSwitch)),
        _createVNode(_unref(uncheckedSwitch)),
        _createVNode(_unref(bordersIcons)),
        _createVNode(_unref(disabledOutline)),
        _createVNode(_unref(variationSwitches)),
        _createVNode(_unref(switchSizing)),
        _createVNode(_unref(switchIcons))
      ])
    ])
  ], 64))
}
}

})